<template>
  <div class="student-login-wrapper">
    <div class="flex-box">
      <!-- <h2 class="">登录</h2> -->
      <div class="flex-j-c login-type" v-if="loginType !== 3">
        <div
          @click="checkLoginType(0)"
          :class="['public-login', 'pointer', loginType ? '' : 'active']"
        >
          快捷登录
        </div>
        <div
          @click="checkLoginType(1)"
          :class="['public-login', 'pointer', loginType ? 'active' : '']"
        >
          密码登录
        </div>
      </div>
      <div class="set-user login-type" v-if="loginType === 3">
        {{ title }}
      </div>
      <a-form-model
        v-show="loginType === 0"
        :model="loginForm"
        ref="loginForm"
        :rules="rules"
        class="login-form"
        v-bind="layout"
        :hideRequiredMark="true"
        labelAlign="left"
      >
        <a-form-model-item prop="phone" label="手机号">
          <a-input
            class="set-input"
            v-model.trim="loginForm.phone"
            :size="formSize"
          >
          </a-input>
        </a-form-model-item>
        <a-form-model-item prop="code" class="random" label="验证码">
          <a-input
            class="set-input"
            :size="formSize"
            v-model.trim="loginForm.code"
            type="text"
            @keypress.enter.native="handleSubmit"
          >
          </a-input>
          <a-button
            class="set-button"
            block
            type="primary"
            :size="formSize"
            @click="getSendCode(loginForm.phone)"
            :disabled="isSendCode"
          >
            获取验证码
          </a-button>
        </a-form-model-item>
        <div class="hint" v-if="isSendCode">
          <span>{{ time }}秒后重新发送验证码</span>
        </div>
      </a-form-model>
      <a-form-model
        v-show="loginType === 1"
        :model="loginForm1"
        ref="loginForm1"
        :rules="rules"
        class="login-form"
        v-bind="layout"
        :hideRequiredMark="true"
        labelAlign="left"
      >
        <a-form-model-item prop="phone" label="手机号">
          <a-input
            class="set-input"
            v-model.trim="loginForm1.phone"
            :size="formSize"
          >
          </a-input>
        </a-form-model-item>
        <a-form-model-item
          prop="password"
          label="密码"
          style="height: 40px; margin-bottom: 24px"
        >
          <a-input-password
            class="set-input"
            v-model.trim="loginForm1.password"
            :size="formSize"
            placeholder="请输入6~12位字母与数字组合"
          >
          </a-input-password>
        </a-form-model-item>
      </a-form-model>
      <a-form-model
        v-show="loginType === 3"
        :model="loginForm2"
        ref="loginForm2"
        :rules="rules"
        class="login-form"
        v-bind="layout"
        :hideRequiredMark="true"
        labelAlign="left"
      >
        <a-form-model-item prop="phone" label="手机号">
          <a-input
            class="set-input"
            v-model.trim="loginForm2.phone"
            :size="formSize"
          >
          </a-input>
        </a-form-model-item>
        <a-form-model-item prop="code" class="random" label="验证码">
          <a-input
            class="set-input"
            v-model.trim="loginForm2.code"
            :size="formSize"
          >
          </a-input>
          <a-button
            class="set-button"
            block
            type="primary"
            :size="formSize"
            @click="getSendCode(loginForm2.phone)"
            :disabled="isSendCode"
          >
            获取验证码
          </a-button>
        </a-form-model-item>
        <div class="hint" v-if="isSendCode">
          <span>{{ time }}秒后重新发送验证码</span>
        </div>
        <a-form-model-item prop="setPsw" label="设置密码">
          <a-input-password
            class="set-input"
            v-model.trim="loginForm2.setPsw"
            :size="formSize"
            placeholder="请输入6~12位字母与数字组合"
            @change="change"
          >
          </a-input-password>
        </a-form-model-item>
        <a-form-model-item prop="confirmPsw" label="确认密码">
          <a-input-password
            class="set-input"
            v-model.trim="loginForm2.confirmPsw"
            :size="formSize"
          >
          </a-input-password>
        </a-form-model-item>
      </a-form-model>
      <div class="login-button" v-if="loginType !== 3">
        <div class="tool">
          <div class="pointer" @click="changeTitle(0)">注册</div>
          <div class="pointer" @click="changeTitle(1)">忘记密码</div>
        </div>
        <a-button
          block
          type="primary"
          :size="formSize"
          @click="handleSubmit"
          :loading="loading"
          style="margin-top: 10px"
        >
          登录
        </a-button>
        <!-- <img
          src="../../assets/login-btn.png"
          width="356px"
          height="58px"
          style="margin-top: 10px"
          @click="handleSubmit"
        /> -->
        <div class="flex-j-b flex-a-c">
          <div style="color: #8c8c8c; margin-top: 10px">
            登录即代表您已阅读并同意
            <a @click="toPrivacy">《隐私声明》</a>
          </div>
        </div>
      </div>
      <div class="login-button" v-if="loginType === 3">
        <div class="textalign-r pointer" @click="goLogin">去登录</div>
        <a-button
          block
          type="primary"
          :size="formSize"
          @click="Submit"
          :loading="confirmLoading"
          style="margin: 10px 0"
        >
          {{ isRegister ? "注册" : "确定" }}
        </a-button>
      </div>
      <div class="third-party" v-if="loginType !== 3">
        <a-divider class="wechat-login">微信登录</a-divider>
        <img @click="wechatLogin" src="~@/assets/weixin.png" width="40" />
      </div>
    </div>

    <img class="footer-logo" src="~@/assets/eye/footer-logo.png" width="490" />
  </div>
</template>
<script>
var outPsw = "";
const checkPhone = (rule, phone, callback) => {
  if (!/^1[3456789]\d{9}$/.test(phone)) {
    callback(new Error("请输入正确手机号"));
  }
  callback();
};
const checkpwd = (rule, password, callback) => {
  if (!/^(?![^a-zA-Z]+$)(?!\D+$).{6,12}$/.test(password)) {
    callback(new Error("请输入6~12位字母与数字组合"));
  }
  callback();
};
const checkPwsAgreement = (rule, confirmPsw, callback) => {
  if (confirmPsw !== outPsw) {
    callback(new Error("两次密码输入不一致"));
  }
  callback();
};
import { sendCode, getPassword, studentStatus } from "@/api/user.js";
import { mapGetters, mapActions } from "vuex";
import rolesMixin from "@/mixins/roles";

export default {
  mixins: [rolesMixin],
  data() {
    return {
      title: "",
      loginType: 0, // 0快捷登录 1密码登录 2注册找回密码
      isRegister: true,
      privacy: false,
      isSendCode: false,
      isauthCode: true,
      time: 120,
      timer: null,
      layout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 18 }
      },
      loginForm: {
        phone: "",
        code: ""
      },
      loginForm1: {
        phone: "",
        password: ""
      },
      loginForm2: {
        phone: "",
        code: "",
        setPsw: "",
        confirmPsw: ""
      },
      rules: {
        phone: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur"
          },
          {
            validator: checkPhone,
            message: "请输入正确手机号",
            trigger: "blur"
          }
        ],
        code: [
          {
            required: true,
            message: "请输入验证码",
            trigger: "blur"
          }
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur"
          },
          {
            validator: checkpwd,
            message: "密码为6~12位字母与数字组合",
            trigger: "blur"
          }
        ],
        setPsw: [
          {
            required: true,
            message: "请设置密码",
            trigger: "blur"
          },
          {
            validator: checkpwd,
            message: "密码为6~12位字母与数字组合",
            trigger: "blur"
          }
        ],
        confirmPsw: [
          {
            required: true,
            message: "请确认密码",
            trigger: "blur"
          },
          {
            validator: checkpwd,
            message: "密码为6~12位字母与数字组合",
            trigger: "blur"
          },
          {
            validator: checkPwsAgreement,
            message: "两次密码输入不一致",
            trigger: "blur"
          }
        ]
      },
      loading: false,
      confirmLoading: false,
      applyStatus: 0 //: 0-待提交; 1-待通过; 2-认证未通过; 3-已通过
    };
  },
  computed: {
    ...mapGetters(["formSize"])
  },
  methods: {
    ...mapActions({
      login: "loginAddSmsCode",
      handleLogin: "wechatLogin",
      passwordLogin: "passwordLogin",
      registerLogin: "registerLogin"
    }),
    checkLoginType(val) {
      this.loginType = val;
    },
    toPrivacy() {
      window.open("/privacy");
    },
    goLogin() {
      this.loginType = 1;
    },
    change() {
      outPsw = this.loginForm2.setPsw;
    },
    changeTitle(type) {
      if (type) {
        this.isRegister = false;
        this.title = "找回密码";
      } else {
        this.isRegister = true;
        this.title = "注册";
      }
      this.loginType = 3;
    },
    getSendCode(phone) {
      if (!/^1[3456789]\d{9}$/.test(phone)) {
        this.$message.error("请输入正确手机号");
        return;
      }
      const params = {
        phone: phone,
        type: "pcLogin"
      };
      if (this.loginType === 3) {
        if (this.isRegister) {
          params.type = "register";
        } else {
          params.type = "forgotPassword";
        }
      }
      sendCode(params)
        .then(res => {
          if (res.code === 1) {
            this.isSendCode = true;
            this.time = 120;
            if (this.isSendCode) {
              this.timer = setInterval(() => {
                this.time--;
                if (this.time <= 0) {
                  this.isSendCode = false;
                  clearInterval(this.timer);
                }
              }, 1000);
            }
            console.log(res);
          }
        })
        .catch(e => {
          console.error(e);
        });
    },
    handleSubmit() {
      if (this.loginType === 0) {
        this.$refs.loginForm.validate(valid => {
          if (valid) {
            this._loginCode();
          }
        });
      } else if (this.loginType === 1) {
        this.$refs.loginForm1.validate(valid => {
          if (valid) {
            this._loginPsw();
          }
        });
      }
    },
    _loginPsw() {
      let params = {
        password: this.loginForm1.password,
        userName: this.loginForm1.phone
      };
      this.passwordLogin(params)
        .then(res => {
          if (res.status === 1) {
            this.$router.replace("/");
          } else {
            this._studentStatus();
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    _loginCode() {
      this.loading = true;
      this.login(this.loginForm)
        .then(res => {
          if (res.status === 1) {
            this.$router.replace("/");
          } else {
            this._studentStatus();
          }
        })
        .catch(e => {
          this.loading = false;
          console.error(e);
        });
    },
    async _studentStatus() {
      await studentStatus().then(res => {
        this.applyStatus = res.results.applyStatus;
        if (this.applyStatus === 0) {
          // this.$router.replace("/applySubject");
          // 23.6.16修改
          this.$router.replace({
            name: "CompleteUserInfo"
          });
        } else {
          this.$router.push({ name: "StudentCourseList" });
        }
      });
    },
    wechatLogin() {
      const appId = process.env.VUE_APP_APPID;
      const redirectUri = process.env.VUE_APP_REDIRECT_URI;
      window.location = `https://open.weixin.qq.com/connect/qrconnect?appid=${appId}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_login&state=EYE_PC_LOGIN#wechat_redirect`;
    },
    Submit() {
      if (this.loginForm2.setPsw !== this.loginForm2.confirmPsw) {
        this.$message.error("密码输入不一致");
        return;
      }
      this.$refs.loginForm2.validate(valid => {
        if (valid) {
          this.confirmLoading = true;
          if (this.isRegister) {
            this._register();
          } else {
            this.getPwd();
          }
        }
      });
    },
    _register() {
      let params = {
        code: this.loginForm2.code,
        password1: this.loginForm2.setPsw,
        password2: this.loginForm2.confirmPsw,
        phone: this.loginForm2.phone
      };
      this.registerLogin(params)
        .then(res => {
          this.confirmLoading = false;
          if (res.status === 1) {
            this.$router.replace("/");
          } else {
            this._studentStatus();
          }
        })
        .catch(err => {
          this.confirmLoading = false;
          console.log(err);
        });
    },
    getPwd() {
      let params = {
        code: this.loginForm2.code,
        password1: this.loginForm2.setPsw,
        password2: this.loginForm2.confirmPsw,
        phone: this.loginForm2.phone
      };
      getPassword(params)
        .then(() => {
          this.confirmLoading = false;
          this.loginType = 1;
          this.$message.success("密码修改成功");
        })
        .catch(err => {
          this.confirmLoading = false;
          console.log(err);
        });
    }
  }
};
</script>
<style lang="less">
.random .ant-form-item-children {
  display: flex;
  justify-content: space-between;
}
.set-input .ant-input {
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  border-bottom: 1px solid #d9d9d9 !important;
  border-radius: 0 !important;
}

.set-input .ant-input:focus,
.set-input .ant-input:hover,
.has-error .ant-input:focus {
  // 取消输入框默认效果
  border-bottom: 1px solid #d9d9d9 !important;
  box-shadow: none !important;
}
</style>
<style lang="less" scoped>
.student-login-wrapper {
  background: #ffffff;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px 0;
  justify-content: center;
  min-height: 280px;
  .flex-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex: 1;
  }
  .login-type {
    width: 375px;
    margin: 20px auto;
    padding: 0 5px;
    justify-content: start;
  }
  .set-user {
    font-size: 16px;
    font-weight: bold;
    color: #3e6394;
  }
  .public-login {
    font-size: 16px;
    font-weight: bold;
    color: #bbbbbb;
    margin-right: 25px;
  }
  .active {
    color: #3e6394;
    border-bottom: 2px solid #3e6394;
  }
  .tool {
    display: flex;
    justify-content: space-between;
    color: #3e6394;
  }
  .login-form {
    width: 375px;
    padding: 0 5px;
    box-sizing: border-box;
    margin: 0 auto;
    .set-input {
      border-top: none !important;
      border-left: none !important;
      border-right: none !important;
      border-radius: 0 !important;
    }

    .random-input {
      width: 260px;
      margin-right: 10px;
    }
    .set-button {
      background: #ffffff;
      color: #234b86;
      border-top: none;
      border-left: none;
      border-right: none;
      border-radius: 0;
      border-bottom: 1px solid #d9d9d9;
      box-shadow: none;
    }
    .hint {
      margin-bottom: 24px;
      text-align: right;
    }
    .code-img {
      cursor: pointer;
    }
  }
  .third-party {
    margin: 0 auto;
    width: 375px;
    text-align: center;
    .wechat-login {
      font-size: 14px;
      color: rgba(0, 0, 0, 0.2);
    }
  }
  .footer-logo {
    align-self: center;
  }
  .login-button {
    width: 375px;
    margin: 0px auto 20px;
    padding: 0 5px;
  }
  .ant-input:focus,
  .ant-input:hover,
  .has-error .ant-input {
    // 取消输入框默认效果
    border-bottom: 1px solid #d9d9d9 !important;
    box-shadow: none;
  }
  .ant-btn::after {
    // 取消ant按钮点击默认效果
    border: 0 none;
    opacity: 0;
    animation: none 0 ease 0 1 normal;
  }
}
</style>
